
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10px","height":"23px","viewBox":"0 0 10 23","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('polygon',{attrs:{"id":"path-1","points":"0 0.0005 9.9996 0.0005 9.9996 23.0005 0 23.0005"}})]),_c('g',{attrs:{"stroke":"currentColor","fill":"currentColor","stroke-width":"1"}},[_c('g',{attrs:{"id":"Group-14"}},[_c('g',{attrs:{"id":"Group-7"}},[_c('mask',{attrs:{"id":"mask-2"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_c('g',{attrs:{"id":"Clip-6"}}),_c('path',{attrs:{"d":"M2.1436,7.6055 L2.1436,6.5275 L2.1436,5.4695 L2.1436,5.2935 C2.1436,4.2765 2.1666,2.7045 2.8326,1.7305 C3.5356,0.7005 4.4996,0.0005 6.1596,0.0005 C8.8616,0.0005 9.9996,0.4265 9.9996,0.4265 L9.4636,3.9505 C9.4636,3.9505 8.5716,3.6645 7.7376,3.6645 C6.9066,3.6645 6.1596,3.9955 6.1596,4.9185 L6.1596,5.2925 L6.1596,6.5265 L6.1596,7.6055 L9.5756,7.6055 L9.3366,11.0455 L6.1596,11.0455 L6.1596,23.0005 L2.1436,23.0005 L2.1436,11.0455 L-0.0004,11.0455 L-0.0004,7.6055 L2.1436,7.6055 Z"}})])])])])
          )
        }
      }
    